import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'

export const UpsellFixedTimeBudgetSettings = ({}) => {
  const { company } = useCurrentSession()
  const isLegacy = company.subscription.isPre2022Legacy

  return (
    <Box
      paddingY="s24"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <UpsellingKit.EmptyState
        moduleRequested={AvailableModules.projects}
        featureRequested={Features.projects_budget}
        requestReason={isLegacy ? ValidReasons.MissingFeatureLegacy : ValidReasons.MissingFeature}
        requestSource={ProjectsUpsellRequestSources.budgetSettings}
        title={i18n.t('project_management.upselling.title')}
        description={i18n.t('project_management.upselling.settings')}
        buttonLabel={i18n.t('project_management.upselling.cta')}
        variant="card"
      />
    </Box>
  )
}
